import React from "react";
import dynamic from "next/dynamic";
import useCheckoutFormRenderState from "../../utils/useCheckoutFormRenderState";
import { checkout_form_types } from "../../constants/CheckoutPages.constants";

const ExpressInterestFormWrapper = dynamic(
    () =>
        import(
            "repoV2/features/CheckoutPages/modules/ExpressInterestSection/modules/ExpressInterestFormWrapper/ExpressInterestFormWrapper"
        )
);

const PaymentDetailsFormWrapper = dynamic(
    () =>
        import(
            "repoV2/features/CheckoutPages/modules/PaymentDetailsSection/modules/CheckoutForm/CheckoutForm"
        )
);

const RenewSubscriptionFormWrapper = dynamic(
    () =>
        import(
            "repoV2/features/CheckoutPages/modules/RenewSubscriptionSection/modules/RenewSubscriptionFormWrapper/RenewSubscriptionFormWrapper"
        )
);

const CheckoutRootFormWrapper = (props: {
    children: JSX.Element | JSX.Element[];
}) => {
    const { children } = props;

    const { formToRender } = useCheckoutFormRenderState();

    switch (formToRender) {
        case checkout_form_types.express_interest_form:
            return (
                <ExpressInterestFormWrapper>
                    {children}
                </ExpressInterestFormWrapper>
            );
        case checkout_form_types.payment_form:
            return (
                <PaymentDetailsFormWrapper>
                    {children}
                </PaymentDetailsFormWrapper>
            );
        case checkout_form_types.renew_subscription_form:
            return (
                <RenewSubscriptionFormWrapper>
                    {children}
                </RenewSubscriptionFormWrapper>
            );
        default:
            return <>{children}</>;
    }
};

export default CheckoutRootFormWrapper;
